import { defineMessages } from 'react-intl';

const externalLinksTranslations = defineMessages({
    ng_extLinks_externalLinks: {
        id: 'ng_sidebar_externalLinks',
        defaultMessage: 'External Links'
    },
    ng_extLinks_createNewExternalLink: {
        id: 'ng_createNewExternalLink',
        defaultMessage: 'Create New External Link'
    },
    ng_extLinks_createNewExternalLinkMessage: {
        id: 'ng_createNewExternalLinkMessage',
        defaultMessage: 'Select the below button to create a new external link.'
    },
    ng_extLinks_externalLinksDescription: {
        id: 'ng_extLinks_externalLinksDescription',
        defaultMessage: 'View and manage external links for the mobile app.'
    },
    ng_extLinks_externalLinksSearchPlaceholder: {
        id: 'ng_extLinks_externalLinksSearchPlaceholder',
        defaultMessage: 'Search External Links ...'
    },
    ng_extLinks_externalLinksSummaryTitle: {
        id: 'ng_extLinks_externalLinksSummaryTitle',
        defaultMessage: 'External Link Summary'
    },
    ng_extLinks_externalLinksSummaryDescription: {
        id: 'ng_extLinks_externalLinksSummaryDescription',
        defaultMessage: 'External link information will be displayed here.'
    },
    ng_extLinks_createExternalLink: {
        id: 'ng_extLinks_createExternalLink',
        defaultMessage: 'Create External Link'
    },
    ng_extLinks_externalLinkSummary: {
        id: 'ng_extLinks_externalLinkSummary',
        defaultMessage: 'External Link Summary'
    },
    ng_extLinks_externalLinkSummaryDescText: {
        id: 'ng_extLinks_externalLinkSummaryDescText',
        defaultMessage: 'Add details related to the external link you are adding.'
    },
    ng_extLinks_linkDisplayName: {
        id: 'ng_extLinks_linkDisplayName',
        defaultMessage: 'Link Display Name'
    },
    ng_extLinks_appliedDivisions: {
        id: 'ng_applied_divisions',
        defaultMessage: 'Applied Divisions'
    },
    ng_extLinks_linkURL: {
        id: 'ng_extLinks_linkURL',
        defaultMessage: 'Link URL'
    },
    ng_extLinks_linkURLPlaceholder: {
        id: 'ng_extLinks_linkURLPlaceholder',
        defaultMessage: 'Enter URL'
    },
    ng_extLinks_searchDivisionsPlaceholder: {
        id: 'ng_extLinks_searchDivisionsPlaceholder',
        defaultMessage: 'Search divisions...'
    },
    ng_extLinks_searchNoData: {
        id: 'ng_extLinks_searchNoData',
        defaultMessage: 'No data from search.'
    },
    ng_extLinks_searchNoDivisions: {
        id: 'ng_extLinks_searchNoDivisions',
        defaultMessage: 'No divisions available from search.'
    },
    ng_extLinks_cancel: {
        id: 'ng_extLinks_cancel',
        defaultMessage: 'Cancel'
    },
    ng_extLinks_saveAndExit: {
        id: 'ng_extLinks_saveAndExit',
        defaultMessage: 'Save & Exit'
    },
    ng_extLinks_saveAndContinue: {
        id: 'ng_extLinks_saveAndContinue',
        defaultMessage: 'Save & Continue'
    },
    ng_extLinks_subDescription: {
        id: 'ng_extLinks_subDescription',
        defaultMessage: 'View and manage external links.'
    },
    ng_extLinks_deleteExternalLink: {
        id: 'ng_extLinks_deleteExternalLink',
        defaultMessage: 'Delete External Link'
    },
    ng_extLinks_deleteExternalLinkMessage: {
        id: 'ng_extLinks_deleteExternalLinkMessage',
        defaultMessage: 'Are you sure you want to delete this external link?'
    },
    ng_extLinks_deleteExternalLinkMessageNamed: {
        id: 'ng_extLinks_deleteExternalLinkMessageNamed',
        defaultMessage: 'Are you sure you want to delete external link "{linkName}"?'
    },
    ng_extLinks_footerMessage: {
        id: 'ng_extLinks_footerMessage',
        defaultMessage: 'Placeholder'
    },
    ng_extLinks_discardChanges: {
        id: 'ng_extLinks_discardChanges',
        defaultMessage: 'Discard Changes'
    },
    ng_extLinks_discardChangesMessage: {
        id: 'ng_extLinks_discardChangesMessage',
        defaultMessage: 'Are you sure you wish to discard your changes?'
    },
    ng_extLinks_followingFieldsRequired: {
        id: 'ng_extLinks_followingFieldsRequired',
        defaultMessage: 'The following fields are required:'
    },
    ng_extLinks_correctErrors: {
        id: 'ng_extLinks_correctErrors',
        defaultMessage: 'Please correct the following errors:'
    },
    ng_extLinks_displayName_title: {
        id: 'ng_extLinks_displayName_title',
        defaultMessage: 'Display Name'
    },
    ng_extLinks_displayName_error_maxLength: {
        id: 'ng_extLinks_displayName_error_maxLength',
        defaultMessage: 'Display Name exceeds the character limit {0}.'
    },
    ng_extLinks_displayName_error_invalidChar: {
        id: 'ng_extLinks_displayName_error_invalidChar',
        defaultMessage: 'Display Name cannot start or end with single or double quotation marks.'
    },
    ng_extLinks_displayName_error_nameExists: {
        id: 'ng_extLinks_displayName_error_nameExists',
        defaultMessage: 'This display name has already been used for a different URL. Please review the display name.'
    },
    ng_extLinks_url_title: {
        id: 'ng_extLinks_url_title',
        defaultMessage: 'URL'
    },
    ng_extLinks_url_error_maxLength: {
        id: 'ng_extLinks_url_error_maxLength',
        defaultMessage: 'URL exceeds the character limit {0}.'
    },
    ng_extLinks_url_error_invalidChar: {
        id: 'ng_extLinks_url_error_invalidChar',
        defaultMessage: 'URL cannot start or end with single or double quotation marks.'
    },
    ng_extLinks_url_error_invalidFormat: {
        id: 'ng_extLinks_url_error_invalidFormat',
        defaultMessage: 'Invalid URL format.'
    },
    ng_extLinks_divisions_error_required: {
        id: 'ng_extLinks_divisions_error_required',
        defaultMessage: 'At least one division must be selected.'
    },
    ng_extLinks_editLinkSuccess: {
        id: 'ng_extLinks_editLinkSuccess',
        defaultMessage: 'Success - Edits saved.'
    },
    ng_extLinks_createLinkSuccess: {
        id: 'ng_extLinks_createLinkSuccess',
        defaultMessage: 'Success - {linkName} has been saved.'
    },
    ng_extLinks_deleteLinkSuccess: {
        id: 'ng_extLinks_deleteLinkSuccess',
        defaultMessage: 'Successful deletion of {linkName}'
    },
    ng_extLinks_errorFetchingDivision: {
        id: 'ng_extLinks_errorFetchingDivision',
        defaultMessage: 'There was an error fetching the division.'
    },
    ng_extLinks_errorFetchingLinks: {
        id: 'ng_extLinks_errorFetchingLinks',
        defaultMessage: 'There was an error trying to fetch the existing list of external links.'
    },
    ng_extLinks_errorUpdatingLinks: {
        id: 'ng_extLinks_errorUpdatingLinks',
        defaultMessage: 'There was an error trying to update the external link(s).'
    }
});

export default externalLinksTranslations;
